<template>
  <div id="app">

    <router-view ref="routerView"></router-view>

    <div class="progress-dots">
      <router-link to="/welcome" class="progress-dot">Welcome</router-link>
      <router-link to="/details" class="progress-dot">Details</router-link>
      <router-link to="/results" class="progress-dot" :class="{disabled: !filledInInputs}">Results</router-link>
    </div>


    <span class="disclaimer-text">
      <p>By using this benchmark calculator you are acknowledging the <router-link to="/disclaimer">Disclaimer and Assumptions</router-link>.</p>
    </span>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['getAge', 'getScheme', 'getGender', 'getFundBalance', 'getPostcode']),
    filledInInputs() {
      return this.getAge > 0 && this.getFundBalance >= 0 && this.getScheme != '' && this.getGender != ''
    }
  },
}
</script>

<style lang="scss">
/*Import CSS*/
@import 'stylesheets/main.scss'
</style>
